import styled from 'styled-components'

export const Container = styled.div`
  max-width: 100%;
`

export const SectionTitle = styled.h2`
  font-size: 19px;
  font-weight: 600;
  margin-top: 12px;
  color: #2d2f48;
`

export const DescriptionText = styled.div`
  font-size: 16px;
  margin-bottom: 24px;
  color: #333;
`

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
`

export const LeftButtons = styled.div`
  display: flex;
  gap: 12px;
`

export const ModalContainer = styled.div`
  position: absolute;
  background-color: var(--color-white);
  padding: 32px;
  outline: none;
  max-width: 90vw;
  min-width: 1000px;
  border-radius: 12px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
`

export const Title = styled.h2`
  color: var(--color-oxford-blue);
  text-align: center;
  margin-bottom: 8px;
  word-break: break-word;

  font-weight: bold;
  font-size: 24px;
`
